'use client';
import { Inter } from "next/font/google";
import "./globals.css";
import ThemeCustomization from "./themes";
import RTLLayout from "./ui-component/RTLLayout";
import Locales from "./ui-component/Locales";
import NavigationScroll from "./layout/NavigationScroll";
import Snackbar from "./ui-component/extended/Snackbar";
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from '@/app/contexts/ConfigContext';
import { store, persister } from '@/app/store';
import { Provider } from 'react-redux';
import { LocalizationProvider } from "./layout/MainLayout/LocalizationProvider";

export const metadata = {
  title: "Futuriss App",
  description: "Modern system for educational institutions around the world.",
};

export default function Layout1({ children }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persister}>
        <ConfigProvider>
          <LocalizationProvider> {/* Wrap the app with LocalizationProvider */}
            <ThemeCustomization>
              <RTLLayout>
                <Locales>
                  <NavigationScroll>
                    <Snackbar />
                    {children}
                  </NavigationScroll>
                </Locales>
              </RTLLayout>
            </ThemeCustomization>
          </LocalizationProvider>
        </ConfigProvider>
      </PersistGate>
    </Provider>
  );
}